import { Button } from "../components/ui/button";
import { Plus, Printer, Users, LogOut, HardDriveDownload, HardDriveUpload, Crown } from "lucide-react";
import { useLang } from "../lib/i18n";
import InstallButton from "./InstallPrompt";
import LangToggle from "./LangToggle";

export default function Header({ user, onLogout, onAdmin, onAdd, onPrint, onBackup, onRestore, onUpgrade }) {
  var { t } = useLang();
  var isPremium = user.plan === "premium";

  return (
    <header className="flex items-center gap-3 px-6 py-3 bg-white border-b border-slate-200 shrink-0 no-print" data-testid="app-header">
      <div className="flex items-center gap-2.5 shrink-0">
        <img src={process.env.PUBLIC_URL + "/padlock-icon.png"} alt="Logo" className="w-8 h-8 rounded-lg" />
        <span className="font-bold text-slate-800 hidden sm:block">{t.gestione}</span>
      </div>

      <div className="flex-1" />

      <div className="flex items-center gap-1.5">
        <button
          data-testid="plan-badge"
          onClick={!isPremium ? onUpgrade : undefined}
          className={isPremium
            ? "px-2.5 py-1 rounded-full text-[11px] font-bold bg-gradient-to-r from-amber-400 to-yellow-500 text-white cursor-default"
            : "px-2.5 py-1 rounded-full text-[11px] font-bold bg-slate-100 text-slate-500 border border-slate-200 hover:bg-green-50 hover:text-green-700 hover:border-green-200 cursor-pointer transition-colors"}
        >
          {isPremium ? <><Crown className="w-3 h-3 inline mr-1" />Premium</> : "Free"}
        </button>

        <Button data-testid="add-password-button" onClick={onAdd} size="sm" className="bg-gradient-to-r from-green-700 to-green-800 text-white shadow-sm hidden md:flex">
          <Plus className="w-4 h-4 mr-1" /> {t.add}
        </Button>

        <InstallButton />

        <Button data-testid="backup-button" variant="ghost" size="sm" onClick={onBackup} className="text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50">
          <HardDriveDownload className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">{t.backup}</span>
        </Button>

        <Button data-testid="restore-button" variant="ghost" size="sm" onClick={onRestore} className="text-orange-500 hover:text-orange-600 hover:bg-orange-50">
          <HardDriveUpload className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">{t.restore}</span>
        </Button>

        <Button data-testid="print-button" variant="ghost" size="sm" onClick={onPrint} className="text-slate-500 hover:text-slate-700 hover:bg-slate-100">
          <Printer className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">{t.print}</span>
        </Button>

        {user.role === "admin" && (
          <Button data-testid="admin-button" variant="ghost" size="sm" onClick={onAdmin} className="text-amber-600 hover:text-amber-700 hover:bg-amber-50">
            <Users className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">{t.users}</span>
          </Button>
        )}

        <LangToggle />

        <div className="flex items-center gap-2 ml-1 pl-2 border-l border-slate-200">
          <span className="text-xs text-slate-400 hidden sm:block">{user.email}</span>
          <Button data-testid="logout-button" variant="ghost" size="sm" onClick={onLogout} className="text-red-500 hover:text-red-600 hover:bg-red-50">
            <LogOut className="w-4 h-4 mr-1" /> <span className="hidden sm:inline">{t.logout}</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
